import { ExpressTier } from "data-types";
import { resolveExpressShippingTiers } from "./expressShippingTiers";

/**
 * RX default selection (HL-10487): strict priority Urbify > Uber > DHL. Reuses the same
 * ordering used for display so the auto-selected tier always matches what's shown first.
 * Returns null when neither express provider is eligible (caller falls back to DHL).
 */
export const resolveRxAutoDefaultTier = (
  availableExpressTiers: ExpressTier[],
  ignoreAbTestGate: boolean,
): string | null => {
  const { tiersToShow } = resolveExpressShippingTiers(availableExpressTiers, { ignoreAbTestGate });
  return tiersToShow[0]?.tier ?? null;
};

/**
 * Cannabis DHL -> Urbify upgrade (HL-10487): a customer who chose DHL at choose-treatment is
 * moved to same-day (or next-day) Urbify once it's eligible at the same price or cheaper than
 * DHL, since it's strictly faster. Never touches a cart already on express.
 */
export const resolveCannabisAutoUpgradeTier = (
  availableExpressTiers: ExpressTier[],
  regularShippingFee: number,
): string | null => {
  const bestUrbifyTier =
    availableExpressTiers.find(t => t.tier === "same_day" && t.isAvailable && t.fee <= regularShippingFee) ||
    availableExpressTiers.find(t => t.tier === "next_day" && t.isAvailable && t.fee <= regularShippingFee);
  return bestUrbifyTier?.tier ?? null;
};
